/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedProductionWithdrawalRequest
 */
export interface APIPatchedProductionWithdrawalRequest {
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedProductionWithdrawalRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedProductionWithdrawalRequest
     */
    amount?: number;
}

/**
 * Check if a given object implements the APIPatchedProductionWithdrawalRequest interface.
 */
export function instanceOfAPIPatchedProductionWithdrawalRequest(value: object): value is APIPatchedProductionWithdrawalRequest {
    return true;
}

export function APIPatchedProductionWithdrawalRequestFromJSON(json: any): APIPatchedProductionWithdrawalRequest {
    return APIPatchedProductionWithdrawalRequestFromJSONTyped(json, false);
}

export function APIPatchedProductionWithdrawalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedProductionWithdrawalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function APIPatchedProductionWithdrawalRequestToJSON(value?: APIPatchedProductionWithdrawalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'amount': value['amount'],
    };
}

